const storageKey = (userId: string) => `${userId}-whats-new-hint`

export const getPendingWhatsNewHintId = (userId: string): string | null => localStorage.getItem(storageKey(userId))

export const setPendingWhatsNewHintId = (userId: string, messageId: string): void => {
  localStorage.setItem(storageKey(userId), messageId)
}

export const clearPendingWhatsNewHintId = (userId: string): void => {
  localStorage.removeItem(storageKey(userId))
}
